// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PwaInstallationController from "./pwa/installation_controller"
application.register("pwa-installation", PwaInstallationController)

import RegistrationFlowController from './registration_flow_controller';
application.register('registration-flow', RegistrationFlowController);

import FormValidationController from './form_validation_controller';
application.register('form-validation', FormValidationController);

import PasswordStrengthController from './password_strength_controller';
application.register('password-strength', PasswordStrengthController);

import GenderSelectionController from './gender_selection_controller';
application.register('gender-selection', GenderSelectionController);

import InterestSelectionController from './interest_selection_controller';
application.register('interest-selection', InterestSelectionController);

import HobbySelectionController from './hobby_selection_controller';
application.register('hobby-selection', HobbySelectionController);

import PhotoUploadController from './photo_upload_controller';
application.register('photo-upload', PhotoUploadController);

import DiscoverController from './discover_controller';
application.register('discover', DiscoverController);

import ChatController from './chat_controller';
application.register('chat', ChatController);

import CommunitiesController from './communities_controller';
application.register('communities', CommunitiesController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import ProfileFormController from './profile_form_controller';
application.register('profile-form', ProfileFormController);

import RegistrationValidationController from './registration_validation_controller';
application.register('registration-validation', RegistrationValidationController);

import ProfileMenuController from './profile_menu_controller';
application.register('profile-menu', ProfileMenuController);

import MessageFormController from './message_form_controller';
application.register('message-form', MessageFormController);

import ConversationController from './conversation_controller';
application.register('conversation', ConversationController);

import CommunityChannelController from './community_channel_controller';
application.register('community-channel', CommunityChannelController);

import PostFormController from './post_form_controller';
application.register('post-form', PostFormController);

import ToastController from './toast_controller';
application.register('toast', ToastController);

import PushSubscriptionController from './push_subscription_controller';
application.register('push-subscription', PushSubscriptionController);

import TurnstileController from './turnstile_controller';
application.register('turnstile', TurnstileController);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import MenuController from './menu_controller';
application.register('menu', MenuController);

import DisclosureController from './disclosure_controller';
application.register('disclosure', DisclosureController);

import LightboxController from './lightbox_controller';
application.register('lightbox', LightboxController);

import CoverUploadController from './cover_upload_controller';
application.register('cover-upload', CoverUploadController);
